import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Iter 156 — Idioma de comunicación del cliente (código de Configuración → Idiomas; sólo activos). */
export default function LanguageField({ value, onChange, editing }) {
  const [data, setData] = useState({ languages: [], default_language_code: "" });
  useEffect(() => { api.get("/languages/active").then((r) => setData(r.data || { languages: [] })).catch(() => {}); }, []);
  const current = data.languages.find((l) => l.code === value);
  const label = current ? `${current.name} (${current.code})` : value || (data.default_language_code ? `Por defecto (${data.default_language_code})` : "—");

  if (!editing) {
    return (
      <div>
        <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">Idioma</label>
        <div className="text-sm py-2 text-[#111110]" data-testid="customer-field-language-readonly">{label}</div>
      </div>
    );
  }
  return (
    <div>
      <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">Idioma</label>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-2 text-sm rounded-none bg-white" data-testid="customer-field-language">
        <option value="">Por defecto{data.default_language_code ? ` (${data.default_language_code})` : ""}</option>
        {data.languages.map((l) => <option key={l.code} value={l.code}>{l.name} ({l.code})</option>)}
        {value && !current && <option value={value}>{value} (inactivo)</option>}
      </select>
    </div>
  );
}
